import { render, staticRenderFns } from "./StrapiImage.vue?vue&type=template&id=392c1a9a&scoped=true&"
import script from "./StrapiImage.vue?vue&type=script&lang=js&"
export * from "./StrapiImage.vue?vue&type=script&lang=js&"
import style0 from "./StrapiImage.vue?vue&type=style&index=0&id=392c1a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c1a9a",
  null
  
)

export default component.exports